"use client";

import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import type { VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { backendButtonVariants } from "./backend-ui-styles";

export interface BackendButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof backendButtonVariants> {
  asChild?: boolean;
}

const BackendButton = React.forwardRef<HTMLButtonElement, BackendButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";

    return (
      <Comp
        className={cn(backendButtonVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);

BackendButton.displayName = "BackendButton";

export { BackendButton };
